import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth, isAdmin } from "./context/AuthContext";
import PublicLayout from "./components/PublicLayout";
import { Loader } from "./components/Blocks";

import Home from "./pages/Home";
import Discover from "./pages/Discover";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Partners from "./pages/Partners";
import PartnerDetail from "./pages/PartnerDetail";
import Creators from "./pages/Creators";
import CreatorDetail from "./pages/CreatorDetail";
import Challenges from "./pages/Challenges";
import ChallengeDetail from "./pages/ChallengeDetail";
import Join from "./pages/Join";
import Login from "./pages/Login";
import Account from "./pages/Account";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminApplications from "./pages/admin/AdminApplications";
import AdminPeople from "./pages/admin/AdminPeople";
import {
  AdminPartners,
  AdminEvents,
  AdminProfiles,
  AdminChallenges,
  AdminMedia,
  AdminCollaborators,
} from "./pages/admin/AdminCrudPages";
import { AdminChallengeEntries, AdminConsents, AdminAudit } from "./pages/admin/AdminOps";

const Protected = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  if (user === null) return <Loader testid="auth-checking" />;
  if (user === false) return <Navigate to="/connexion" replace />;
  if (adminOnly && !isAdmin(user)) return <Navigate to="/compte" replace />;
  return children;
};

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/decouvrir" element={<Public><Discover /></Public>} />
          <Route path="/evenements" element={<Public><Events /></Public>} />
          <Route path="/evenements/:slug" element={<Public><EventDetail /></Public>} />
          <Route path="/partenaires" element={<Public><Partners /></Public>} />
          <Route path="/partenaires/:slug" element={<Public><PartnerDetail /></Public>} />
          <Route path="/createurs" element={<Public><Creators /></Public>} />
          <Route path="/createurs/:slug" element={<Public><CreatorDetail /></Public>} />
          <Route path="/challenges" element={<Public><Challenges /></Public>} />
          <Route path="/challenges/:slug" element={<Public><ChallengeDetail /></Public>} />
          <Route path="/rejoindre" element={<Public><Join /></Public>} />
          <Route path="/connexion" element={<Public><Login /></Public>} />
          <Route
            path="/compte"
            element={
              <Protected>
                <Public>
                  <Account />
                </Public>
              </Protected>
            }
          />
          <Route
            path="/admin"
            element={
              <Protected adminOnly>
                <AdminLayout />
              </Protected>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="applications" element={<AdminApplications />} />
            <Route path="people" element={<AdminPeople />} />
            <Route path="profiles" element={<AdminProfiles />} />
            <Route path="partners" element={<AdminPartners />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="challenges" element={<AdminChallenges />} />
            <Route path="challenge-entries" element={<AdminChallengeEntries />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="consents" element={<AdminConsents />} />
            <Route path="collaborators" element={<AdminCollaborators />} />
            <Route path="audit" element={<AdminAudit />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
